import { StripeElementStyle } from "@stripe/stripe-js";
import { SxProps, Theme } from '@mui/material/styles';
import { colors } from "./colors";
import React from "react";

export const lineHeight = "1"
export const lineHeightMobile = "1.2"
export const componentSpace = "185px";
export const componentSpaceMobile = "85px";
export const cardSpace = "80px";
export const cardSpaceMobile = "40px";
export const spaceBetweenCardsHorizontally = "10px";
export const spaceBetweenCardsVertically = "20px";
export const middleSpace = "60px";
export const middleSpaceMobile = "30px";
export const smallSpace = "20px";
export const spaceRoadMap = "5vh";
export const scrollMarginTop = "100px";
export const borderRadius = "15px";
export const borderDegug = "0px solid #000000";
export const maxWidthWaitingList = "420px";
// export let fontFamily = "Comic Sans MS, Comic Sans, cursive";

interface AnchorStyle {
    (isActive?: boolean): SxProps<Theme>;
}

// Define a interface para `sxStyles` usando o tipo `AnchorStyle` para `anchor`
interface SxStyles {
    anchor: AnchorStyle;
}

interface Styles {
    attentionModal: React.CSSProperties;
    button: React.CSSProperties;
    chatSessionModal: React.CSSProperties;
    cardElement: StripeElementStyle;
    content: React.CSSProperties;
    criticalErrorPage: React.CSSProperties;
    inPlaceModal: React.CSSProperties;
    inputField: React.CSSProperties;
    inputSelect: React.CSSProperties;
    inputSelectInner: React.CSSProperties;
    link: React.CSSProperties;
    loadingPage: React.CSSProperties;
    navBarMenu: React.CSSProperties;
    needsEmailVerification: React.CSSProperties;
    overlayModal: React.CSSProperties;
    page: React.CSSProperties;
    productModal: React.CSSProperties;
    profileMenu: React.CSSProperties;
    profileMenuAvatar: React.CSSProperties;
    profileMenuModal: React.CSSProperties;
    radio: React.CSSProperties;
    radioGroup: React.CSSProperties;
    searchField: React.CSSProperties;
    searchResultAvatar: React.CSSProperties;
    searchResultList: React.CSSProperties;
    searchResultModal: React.CSSProperties;
    supportModal: React.CSSProperties;
    card: React.CSSProperties;
    mobileCard: React.CSSProperties;
    cardButton: React.CSSProperties;
    planButton: React.CSSProperties;
    discordButton: React.CSSProperties;
    discordImage: React.CSSProperties;
    discordText: React.CSSProperties;
    label: React.CSSProperties;
    divContainer: React.CSSProperties;
    divContainerMobile: React.CSSProperties;
    gridContainer: React.CSSProperties;
    gridContainerMobile: React.CSSProperties;
    footer: React.CSSProperties;
    footerMobile: React.CSSProperties;
    icon: React.CSSProperties;
    roadMapPaper: React.CSSProperties;
    roadMapLogo: React.CSSProperties;
    greenLabel:React.CSSProperties;
}

export const sxStyles:SxStyles = {
    anchor: (isActive?: boolean) => ({
        color: "#fff",
        textDecoration: "none",
        margin: "0 10px",
        position: "relative",
        '&:hover': {
            '&::after': {
                width: '100%',
            },
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: -1,
            height: 2,
            width: isActive ? '100%' : 0, // Preenchido quando isActive é true
            backgroundColor:  "#fff",
            transition: 'width 0.3s ease',
        },
    }),
};

export const styles: Styles = {
    // Pages
    page: {
        alignItems: "center",
        background: colors.background.main,
        color: colors.font.main,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
    },
    content: {
        alignItems: "center",
        background: colors.background.main,
        color: colors.font.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: "100%",
    },
    loadingPage: {
        alignItems: "center",
        backgroundColor: colors.background.main,
        bottom: 0,
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        left: 0,
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: 9999,
    },
    needsEmailVerification: {
        background: colors.background.secondary,
        height: "100vh",
    },
    criticalErrorPage: {
        background: colors.background.secondary,
        height: "100vh",
    },

    // Modals
    attentionModal: {
        alignItems: 'center',
        background: colors.background.quaternary,
        borderRadius: 15,
        left: "50.3%",
        maxHeight: "50vw",
        minWidth: 300,
        overflow: "hidden",
        padding: 25,
        position: "relative",
        top: "50%",
        transform: 'translate(-50%, -50%)',
        width: "33vw",
        zIndex: 1301,
    },
    chatSessionModal: {
        background: colors.background.quaternary,
        borderRadius: 15,
        bottom: "11%",
        overflow: "auto",
        padding: 25,
        position: "fixed",
        right: 20,
        top: undefined,
        width: 500,
        zIndex: 1301,
    },
    inPlaceModal: {
        alignItems: "center",
        backgroundColor: colors.background.primary,
        borderRadius: 30,
        boxShadow: `0px 0px 10px ${colors.background.primary}`,
        display: "flex",
        flexDirection: "column",
        gap: 25,
        justifyContent: "center",
        maxWidth: 650,
        padding: "50px 60px",
    },
    productModal: {
        alignItems: 'center',
        background: colors.background.quaternary,
        borderRadius: 15,
        left: "50.3%",
        maxHeight: "50vw",
        minWidth: 300,
        padding: 25,
        position: "relative",
        top: "50%",
        transform: 'translate(-50%, -50%)',
        width: "33vw",
        zIndex: 1301,
    },
    profileMenuModal: {
        background: colors.background.quaternary,
        borderRadius: 15,
        overflow: "auto",
        padding: 0,
        position: "fixed",
        right: 70,
        top: "11%",
        width: 200,
        zIndex: 1301,
    },
    searchResultModal: {
        background: colors.background.quaternary,
        borderRadius: 15,
        left: "50.3%",
        maxHeight: "50vw",
        minWidth: 300,
        overflow: "hidden",
        padding: 0,
        position: "relative",
        top: "11%",
        transform: 'translate(-50%, 0%)',
        width: "33vw",
        zIndex: 1301,
    },
    supportModal: {
        background: colors.background.quaternary,
        borderRadius: 15,
        overflow: "auto",
        padding: 25,
        position: "fixed",
        right: 20,
        bottom: "11%",
        width: 350,
        zIndex: 1301,
        top: "50%",
    },
    overlayModal: {},

    // Inputs
    cardElement: {
        base: {
            color: colors.font.main,
            fontSize: "18px",

            "::placeholder": {
                color: "#858585",
            },
        },
        invalid: {
            color: colors.font.error,
            iconColor: colors.font.error,
        },
    },
    inputField: {
        alignItems: 'center',
        background: colors.background.main,
        borderRadius: 15,
        display: 'flex',
        minHeight: 70,
        width: "100%"
    },
    inputSelect: {
        background: colors.background.main,
        borderRadius: 15,
        color: colors.font.main,
        height: 70,
        width: "100%",
    },
    inputSelectInner: {
        background: colors.background.main,
        borderRadius: 15,
        color: colors.font.main,
        marginTop: 5,
        padding: 0,
    },
    radio: {
        alignItems: 'center',
        background: colors.background.primary,
        borderRadius: 15,
        color: colors.font.primary,
        display: 'flex',
        fontFamily: "PublicSansThin",
        height: 45,
        margin: 0,
        maxHeight: 45,
        padding: '2px 4px',
        width: "80%",
    },
    radioGroup: {
        alignItems: 'center',
        display: 'flex',
        marginTop: 10,
        maxHeight: "20vh",
        width: "100%",
    },
    navBarMenu: {
        alignItems: "center",
        alignSelf: "flex-start",
        background: colors.background.main,
        color: colors.font.main,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignContent: "center",
        maxWidth: "1600px",
        // borderRadius: 25,
        // width: "100%",
        // minHeight: "11vh",
        padding: "0px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        // height: "90px"
        // background: `linear-gradient(0deg, ${colors.background.main} 0%, ${colors.background.secondary} 100%)`,
        // boxShadow: `0 0 10px 0 ${colors.background.secondary}`,

    },
    searchField: {
        alignItems: 'center',
        background: colors.background.quaternary,
        borderRadius: 15,
        display: 'flex',
        height: 55,
        minWidth: 100,
        padding: '2px 4px',
        width: "33vw",
        zIndex: 1301,
    },

    // Texts
    link: {
        color: colors.font.main,
    },

    // Buttons
    button: {
        borderRadius: 15,
        fontSize: 18,
        fontWeight: "bold",
        height: 70,
        textTransform: "none",
        width: "100%",
        padding: 0,
        margin: 0
    },
    profileMenu: {
        alignItems: 'center',
        background: colors.background.quaternary,
        borderRadius: 15,
        display: 'flex',
        height: 55,
        marginRight: -55,
        padding: '2px 4px',
        width: 200,
    },
    profileMenuAvatar: {
        alignItems: 'center',
        display: 'flex',
        height: 70,
        justifyContent: 'center',
        outline: `solid 6px ${colors.background.primary}`,
        outlineOffset: -2,
        width: 70,
    },
    searchResultAvatar: {
        alignItems: 'center',
        borderRadius: '50%',
        display: 'flex',
        height: 70,
        justifyContent: 'center',
        width: 70,
    },

    // Lists
    searchResultList: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "40vw",
        minWidth: 300,
        overflowX: "hidden",
        overflowY: "auto",
        padding: 0,
    },

    // Home
    card: {
        color: colors.font.main,
        backgroundColor: colors.background.tertiary,
        border: `1px solid ${colors.background.tertiary}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderRadius: 25,
        fontSize: "1em",
        padding: 0,
        height: "375px",
        justifyContent: "center",
        marginLeft: spaceBetweenCardsHorizontally,
        marginRight: spaceBetweenCardsHorizontally,
        marginBottom: spaceBetweenCardsVertically,
        // width: "100%",
        // height: "100%",
        // paddingTop: "5px",
        // paddingLeft: 10,
        // marginLeft: 5,
        // marginRight: 5,
        // margin: "5px",
        // textAlign: "center",
        // width: "100%",
        // boxShadow: `0px 0px 10px ${colors.background.primary}`,
        // gap: 5,
        // border: "1px solid #141416",
        // margin: "0px 10px",
        // width: "100%"
        // color: "#353740",
        // padding: "1%",
    },
    mobileCard: {
        height: "300px",
        // marginLeft: "9px",
        // marginBottom: "0px",
    },
    cardButton: {
        marginTop: "15px",
        height: 80,
        backgroundColor: "inherit", // Sem Fundo
        padding: "10px 20px",
        border: "3px solid #21232B",
        marginBottom: 10,
        width: "100%",
        color: "white",
        borderRadius: "15px"
    },
    planButton: {
        marginTop: "15px",
        // height: 80,
        backgroundColor: "inherit", // Sem Fundo
        padding: "10px 20px",
        border: "3px solid #21232B",
        width: "25%",
        color: "white",
        borderRadius: "15px"
    },
    discordButton: {
        // marginTop: "15px",
        height: "46px",
        width: "200px",
        backgroundColor: colors.button.discord.background,
        borderRadius: "40px",
        padding: 0,
        border: "2px solid transparent",
        display: "flex",
        justifyContent: "center", // Centraliza horizontalmente
        alignItems: "center", // Centraliza verticalmen
    },
    discordImage: {
        width: 50,
        filter: "brightness(0) invert(1)",
        padding: 0,
        marginLeft: "3px",
    },
    discordText: {
        textTransform: "none",
        fontSize: 14,
        color: "white",
        marginRight: "25px",
        padding: 0,
    },
    label: {
        color: colors.background.success
    },
    divContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "200px",
        scrollMarginTop: "100px",
        textAlign: 'center',
        // padding: isDesktop ? "20px 0" : "0",
        // padding: "0",
    },
    divContainerMobile: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "80px",
        textAlign: 'center',
        // padding: isDesktop ? "20px 0" : "0",
        padding: "0 20px", // Adiciona padding condicionalmente
    },
    gridContainer: {
        maxWidth: "1200px",
        width: "100%",
        // margin: 0, // Remove qualquer margem
        // padding: "200px",
        padding: 0,
        justifyContent: "center",
        scrollMarginTop: "100px",
        marginLeft: 0,
        marginRight: 0,
        // margin: 0,
        display: "flex",
        // alignItems: "center",
        // marginTop: "200px",
        // width: "100%",
        // marginLeft: "200px",
        // marginRight: "200px",
        // marginBottom: "20px",
    },
    gridContainerMobile: {
        margin: 0, // Remove qualquer margem

    },
    footer: {
        marginBottom: "50px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    footerMobile: {
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    icon: {
    },
    roadMapPaper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "initial",
        flexDirection: "row",
        height: "1.2in",
        border: "2px solid transparent",
        backgroundColor: colors.button.discord.background,
        cursor: "pointer",

        color: colors.font.main,
        borderRadius: 10,
        fontSize: "1em",
        padding: 0,
        marginLeft: spaceBetweenCardsHorizontally,
        marginRight: spaceBetweenCardsHorizontally,
        marginBottom: spaceBetweenCardsVertically,
    },
    roadMapLogo: {
        display: "flex",
        width: "18%",
        filter: "brightness(0) invert(1)",
    },
    greenLabel:{
        color: colors.background.success
    }
};